import { render, staticRenderFns } from "./CompanyIsSchool.vue?vue&type=template&id=1aa04311&"
import script from "./CompanyIsSchool.vue?vue&type=script&lang=js&"
export * from "./CompanyIsSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports